import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { BannerSection } from './components/BannerSection';
import { ContactSection } from './components/ContactSection';

const ContactPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <BannerSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;